<template>
  <div>
    <v-container>
      <h1 class="pb-4 primary--text font-weight-bold">
        {{
          isEditCustomer
            ? $t("customer.updateCustomer")
            : $t("customer.addCustomer")
        }}
      </h1>
      <v-dialog
        height="130px"
        width="500px"
        rounded="lg"
        v-model="errorDialogue"
      >
        <v-card height="130px" width="500px">
          <v-card-title>
            <h4 class="mx-auto">
              {{ $t("landlord.errorOccured") }}
            </h4>
            <v-btn @click="closeDialog" icon rounded color="success">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center red--text">
            <span class="text-h5"> Error Info: {{ this.isError }} </span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ValidationObserver ref="observer" v-slot="{ valid, handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-x-4">
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true, name: /^[A-Za-z]+$/ }"
                :name="$t('customer.firstName')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  color="secondary"
                  type="text"
                  v-model="customerModelObj.firstName"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.firstName") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true, name: /^[A-Za-z]+$/ }"
                :name="$t('customer.lastName')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('customer.lastName')"
                  color="secondary"
                  type="text"
                  v-model="customerModelObj.lastName"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.lastName") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ phone: 8, required: true }"
                :name="$t('customer.phone')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  class="numberClass"
                  :label="$t('customer.phone')"
                  color="secondary"
                  type="number"
                  v-model="customerModelObj.phone"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.phone") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|email"
                :name="$t('customer.email')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('customer.email')"
                  color="secondary"
                  type="text"
                  v-model="customerModelObj.email"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.email") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <v-switch
                class="mt-0"
                v-model="customerModelObj.active"
                :label="$t('landlord.isActive')"
                color="primary"
              >
                <!-- <template #prepend>
                  <v-label>{{ $t("landlord.isActive") }}</v-label>
                </template> -->
              </v-switch>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :name="
                  isEditCustomer ? $t('user.newPassword') : $t('user.password')
                "
                vid="confirm"
                :rules="{ minPass: 6, required: isEditCustomer ? false : true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  @click:append="show = !show"
                  :label="
                    isEditCustomer
                      ? $t('user.newPassword')
                      : $t('user.password')
                  "
                  color="secondary"
                  v-model="customerModelObj.newPassword"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{
                      isEditCustomer
                        ? $t("user.newPassword")
                        : $t("user.password")
                    }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div
              v-if="!isEditLandlord"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="
                  isEditCustomer
                    ? { minPass: 6, maxPass: 20, confirmed: 'confirm' }
                    : {
                        minPass: 6,
                        maxPass: 20,
                        confirmed: 'confirm',
                        required: true
                      }
                "
                :name="$t('landlord.confirmPassword')"
              >
                <v-text-field
                  :error-messages="errors"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  outlined
                  data-vv-as="password"
                  dense
                  :label="$t('landlord.confirmPassword')"
                  color="secondary"
                  v-model="confirmPassword"
                  @click:append="show = !show"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.confirmPassword") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>

            <!-- <v-col cols="12" sm="6" md="4" lg="6" class="py-0 ">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                  outlined
                  disabled
                :error-messages="errors"
                dense
                :label="$t('customer.role')"
                color="secondary"
                type="text"
                v-model="customerModelObj.role"
              >
              </v-text-field>
            </ValidationProvider>
          </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="6">
            <p class="mb-1 gray1--text">
              {{ 'User Image' }}
            </p>
            <image-uploader
            :maxWidth="200"
            :max-height="200"
            :quality="0.9"
            :preview="true"
            :className="['fileinput', { 'fileinput--loaded': hasLogo }]"
            capture="environment"
            :debug="1"
            doNotResize="gif"
            :autoRotate="true"
            outputFormat="blob"
                @input="setLogo"
                class="ms-2"
                id="logo"
                >
                <label for="logo" slot="upload-label">
                  <v-col align="start" class="pa-0 ma-0">
                    <a>
                      <div v-if="!hasLogo" class="upload-caption gray1--text">
                        <v-avatar
                        v-if="customerModelObj.avatar"
                        class="mx-4"
                        :size="100"
                        :src="`${
                          $store.getters.imageBaseUrl
                        }/${
                          customerModelObj.avatar
                        }`"
                        />
                        <v-avatar
                        class="mx-4 red"
                        :size="100"
                        >
                      </v-avatar>
                    </div>
                  </a>
                  <p class="my-0 upload-caption grey--text">
                    {{
                      hasLogo
                      ? $t("landlord.clicktochange")
                      : $t("landlord.clicktoupload")
                    }}
                  </p>
                  </v-col>
                </label>
              </image-uploader>
            </v-col> -->
            <div>
              <ValidationProvider
                :rules="{ required: true }"
                v-slot="{ errors }"
                :name="$t('customer.civilIdNumber')"
              >
                <v-text-field
                  maxlength="12"
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('customer.civilIdNumber')"
                  v-model="customerModelObj.civilIdNumber"
                  color="secondary"
                  type="text"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.civilIdNumber") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>

            <div
              v-if="!isEditCustomer"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{
                  required: true,
                  maxSize: 8000
                }"
                :name="$t('customer.civilIdImageFront')"
              >
                <v-file-input
                  :label="$t('customer.civilIdImageFront')"
                  :error-messages="errors"
                  prepend-icon=""
                  append-icon="mdi-folder-open"
                  accept=".xlsx, .xls, .pdf, image/*"
                  v-model="file"
                  outlined
                  dense
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.civilIdImageFront") }}
                  </template>
                </v-file-input>
              </ValidationProvider>
            </div>
            <div
              v-if="!isEditCustomer"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{
                  required: true,
                  maxSize: 8000
                }"
                :name="$t('customer.civilIdImageBack')"
              >
                <v-file-input
                  :error-messages="errors"
                  :label="$t('customer.civilIdImageBack')"
                  outlined
                  accept=".xlsx, .xls, .pdf, image/*"
                  prepend-icon=""
                  append-icon="mdi-folder-open"
                  v-model="file1"
                  dense
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.civilIdImageBack") }}
                  </template>
                </v-file-input>
              </ValidationProvider>
            </div>
            <div class=" tw-flex tw-flex-col tw-mb-4 lg:tw-mb-0 tw-gap-2"
              v-if="isEditCustomer"
            >

                <p class=" tw-text-sm pa-0 ma-0">{{ $t("customer.civilIdImageFront") }}</p>

              <v-card outlined>
                <v-card
                  height="150px"
                  @click="onClickImageFront()"
                  flat
                  class="justify-center rounded-lg card-custom-border d-flex"
                >
                  <div>
                    <v-img
                      v-if="imageFront"
                      class="mx-auto"
                      :src="
                        imageFrontUrl ||
                          `${$store.getters.imageBaseUrl}/${customerModelObj.civilIdImageFront}`
                      "
                      width="260"
                      height="115"
                      contain
                    ></v-img>
                    <v-img
                      v-else
                      class="mx-auto"
                      :src="require('@/assets/no-image.jpg')"
                      width="50px"
                    ></v-img>
                    <ValidationProvider
                      :rules="{
                        maxSize: 8000
                      }"
                    >
                      <v-file-input
                        v-model="imageFront"
                        v-show="false"
                        accept="image/*"
                        ref="imageFront"
                        :label="$t('common.fileInput')"
                      ></v-file-input>
                    </ValidationProvider>
                  </div>
                </v-card>
                <div class="text-center">
                  <v-btn
                    icon
                    color="info"
                    @click="downloadFiles(customerModelObj.civilIdImageFront)"
                  >
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
            <!-- <v-col> -->
            <!-- <div>CivilId Front Image</div>
              <v-img
                v-if="customerModelObj.civilIdImageFront"
                class=""
                :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${customerModelObj.civilIdImageFront}
                `"
                max-height="150"
                max-width="250"
                :src="`
                  ${$store.getters.imageBaseUrl}/${customerModelObj.civilIdImageFront}
                  `"
              ></v-img>
              <v-img
                v-else
                :lazy-src="require('@/assets/no-image.jpg')"
                max-height="150"
                max-width="250"
                :src="require('@/assets/no-image.jpg')"
              ></v-img>
              <div class="text-center">
                <v-btn
                  icon
                  color="info"
                  @click="downloadFiles(customerModelObj.civilIdImageFront)"
                >
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </v-col> -->
             <div class=" tw-mb-4 tw-flex tw-flex-col tw-gap-2"
              v-if="isEditCustomer"
            >

                <p class="tw-text-sm pa-0 ma-0">{{ $t("customer.civilIdImageBack") }}</p>

              <v-card outlined>
                <v-card
                  height="150px"
                  @click="onClickImageBack()"
                  flat
                  class="justify-center rounded-lg card-custom-border d-flex"
                >
                  <div>
                    <v-img
                      v-if="imageBack"
                      class="mx-auto"
                      :src="
                        imageBackUrl ||
                          `${$store.getters.imageBaseUrl}/${customerModelObj.civilIdImageBack}`
                      "
                      width="260"
                      height="115"
                      contain
                    ></v-img>
                    <v-img
                      v-else
                      class="mx-auto"
                      :src="require('@/assets/no-image.jpg')"
                      width="50px"
                    ></v-img>
                    <ValidationProvider
                      :rules="{
                        maxSize: 8000
                      }"
                    >
                      <v-file-input
                        v-model="imageBack"
                        v-show="false"
                        accept="image/*"
                        ref="imageBack"
                        :label="$t('common.fileInput')"
                      >
                        <template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("common.fileInput") }}
                        </template>
                      </v-file-input>
                    </ValidationProvider>
                  </div>
                </v-card>
                <div class="text-center">
                  <v-btn
                    icon
                    color="info"
                    @click="downloadFiles(customerModelObj.civilIdImageBack)"
                  >
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
            <!-- <div>CivilId Back Image</div>
              <v-img
                v-if="customerModelObj.civilIdImageBack"
                class=""
                :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${customerModelObj.civilIdImageBack}
                `"
                max-height="150"
                max-width="250"
                :src="`
                  ${$store.getters.imageBaseUrl}/${customerModelObj.civilIdImageBack}
                  `"
              ></v-img>
              <v-img
                v-else
                :lazy-src="require('@/assets/no-image.jpg')"
                max-height="150"
                max-width="250"
                :src="require('@/assets/no-image.jpg')"
              ></v-img>
              <div class="text-center">
                <v-btn
                  icon
                  color="info"
                  @click="downloadFiles(customerModelObj.civilIdImageBack)"
                >
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="6" class="py-0" v-if="!isEditCustomer">
              <ValidationProvider v-slot="{ errors }" :rules="{
                required: true,
                maxSize: 8000
              }">
                <v-file-input :label="$t('user.signup.passportImageFront')" prepend-icon=""
                  append-icon="mdi-folder-open" :error-messages="errors" accept=".xlsx, .xls, .pdf, image/*"
                  v-model="passportFrontFile" outlined dense>
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>{{$t('user.signup.passportImageFront')}}
                  </template>
                </v-file-input>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6" class="py-0" v-if="!isEditCustomer">
              <ValidationProvider v-slot="{ errors }" :rules="{
                required: true,
                maxSize: 8000
              }">
                <v-file-input :label="$t('user.signup.passportImageBack')" outlined accept=".xlsx, .xls, .pdf, image/*"
                  prepend-icon="" append-icon="mdi-folder-open" v-model="passportBackFile" :error-messages="errors"
                  dense>
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>{{$t('user.signup.passportImageBack')}}
                  </template>
                </v-file-input>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" class="py-3" v-if="isEditCustomer">
              <div>
                <p class="">{{ $t("user.signup.passportImageFront") }}</p>
              </div>
              <v-card outlined>
                <v-card height="150px" @click="onClickPassportFront()" flat
                  class="justify-center rounded-lg card-custom-border d-flex">
                  <div>
                    <v-img v-if="customerModelObj.passportImageFront" class="mx-auto" :src="
                      passportFrontUrl ||
                      `${$store.getters.imageBaseUrl}/${customerModelObj.passportImageFront}`
                    " width="260" height="115" contain></v-img>
                    <v-img v-else class="mx-auto" max-width="100%" max-height="100%" contain
                      :src="require('@/assets/no-image.jpg')" width=""></v-img>
                    <ValidationProvider :rules="{
                      maxSize: 8000
                    }">
                      <v-file-input v-model="passportFront" v-show="false" accept="image/*" ref="passportFront"
                        :label="$t('common.fileInput')"></v-file-input>
                    </ValidationProvider>
                  </div>
                </v-card>
                <div class="text-center">
                  <v-btn icon color="info" @click="downloadFiles(customerModelObj.passportImageFront)">
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" class="py-3" v-if="isEditCustomer">
              <div>
                <p class="">{{ $t('user.signup.passportImageBack') }}</p>
              </div>
              <v-card outlined>
                <v-card height="150px" @click="onClickPassportBack()" flat
                  class="justify-center rounded-lg card-custom-border d-flex">
                  <div>
                    <v-img v-if="customerModelObj.passportImageBack" class="mx-auto" :src="
                      passportBackUrl ||
                      `${$store.getters.imageBaseUrl}/${customerModelObj.passportImageBack}`
                    " width="260" height="115" contain></v-img>
                    <v-img v-else class="mx-auto" max-width="100%" max-height="100%" contain
                      :src="require('@/assets/no-image.jpg')"></v-img>
                    <ValidationProvider :rules="{
                      maxSize: 8000
                    }">
                      <v-file-input v-model="passportBack" v-show="false" accept="image/*" ref="passportBack"
                        :label="$t('common.fileInput')"></v-file-input>
                    </ValidationProvider>
                  </div>
                </v-card>
                <div class="text-center">
                  <v-btn icon color="info" @click="downloadFiles(customerModelObj.passportImageBack)">
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col> -->


            <!-- <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col> -->
          </div>

            <div class=" tw-flex tw-justify-end">
              <!-- <div class="d-flex justify-space-around"> -->
              <!-- <v-btn class="custom-button text-none" @click="onCancel">
                {{ $t('common.cancel')}}
                </v-btn> -->
              <v-btn
                class="white--text"
                color="primary"
                style="width: 20%;"
                type="submit"
                :disabled="!valid"
                :loading="btnLoading"
              >
                {{ isEditCustomer ? $t("common.update") : $t("common.save") }}
              </v-btn>
              <!-- </div> -->
            </div>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { updateCustomer } from "../../methods/customer/updateCustomer";
import { signUp } from "../../methods/customer/createCustomer";
// import { checkPhoneExist } from "../../methods/customer/checkExitPhone"
// import imageUploader from "vue-image-upload-resize";
// import Avatar from "vue-avatar";
export default {
  data() {
    return {
      errorDialogue: false,
      file: null,
      file1: null,
      passportFrontFile: null,
      confirmPassword: "",
      passportBackFile: null,
      hasLogo: false,
      reRender: 0,
      btnLoading: false,
      civilIdImageFront: null,
      civilIdImageBack: null,
      passportImageFront: null,
      passportImageBack: null,
      imageFront: [],
      passportBack: [],
      passportFront: [],
      imageBack: [],
      customerModelObj: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        active: true,
        civilIdImageFront: "",
        civilIdImageBack: ""
      },
      isError: null,
      show: false,
      imageFrontUrl: null,
      imageBackUrl: null,
      passportFrontUrl: null,
      passportBackUrl: null
    };
  },
  components: {
    // 'image-uploader': imageUploader,
    // 'avatar': Avatar,
    // Alert: () => import("@/core/components/Alert.vue"),
  },
  mounted() {
    if (this.isEditCustomer)
      this.customerModelObj = this.$format.cloneVariable(this.editCustomer);
  },
  computed: {
    ...mapGetters(["isEditCustomer", "editCustomer"])
  },
  watch: {
    isError(val) {
      if (val) {
        this.errorDialogue = true;
      } else {
        this.errorDialogue = false;
      }
    },
    imageFront: {
      handler() {
        this.imageFrontUrl = URL.createObjectURL(this.imageFront);
        this.customerModelObj.civilIdImageFront = this.imageFront;
      }
    },
    imageBack: {
      handler() {
        this.imageBackUrl = URL.createObjectURL(this.imageBack);
        this.customerModelObj.civilIdImageBack = this.imageBack;
      }
    },
    passportFront: {
      handler() {
        this.passportFrontUrl = URL.createObjectURL(this.passportFront);
        this.customerModelObj.passportImageFront = this.passportFront;
      }
    },
    passportBack: {
      handler() {
        this.passportBackUrl = URL.createObjectURL(this.passportBack);
        this.customerModelObj.passportImageBack = this.passportBack;
      }
    },
    isEditCustomer: {
      handler() {
        if (this.isEditCustomer) {
          this.customerModelObj = this.$format.cloneVariable(this.editCustomer);
          // console.log(this.customerModelObj);
        } else {
          this.hasLogo = false;
          this.customerModelObj = {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            active: true,
            civilIdNumber: ""
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  methods: {
    closeDialog() {
      this.errorDialogue = false;
      this.isError = null;
      this.rerender += 1;
    },
    onClickImageFront() {
      this.$refs.imageFront.$refs.input.click();
    },
    onClickImageBack() {
      this.$refs.imageBack.$refs.input.click();
    },
    onClickPassportFront() {
      this.$refs.passportFront.$refs.input.click();
    },
    onClickPassportBack() {
      this.$refs.passportBack.$refs.input.click();
    },
    setLogo(output) {
      this.hasLogo = true;
      this.customerModelObj.avatar = output;
    },
    downloadFiles(link) {
      const fileUrl = this.imageBaseUrl + "/" + link;
      console.log(fileUrl);
      var a = document.createElement("a");
      a.href = fileUrl;
      a.setAttribute("download", null);
      a.click();
    },
    async onSave() {
      this.btnLoading = true;
      const input = this.$format.cloneVariable(this.customerModelObj);
      const createInput = {
        id: input._id,
        input: {
          firstName: input.firstName,
          lastName: input.lastName,
          email: input.email,
          phone: input.phone,
          // avatar: input.avatar,
          // password: "",
          // civilIdNumber: input.civilIdNumber,
          // civilIdImageBack: this.file1,
          // civilIdImageFront: this.file,
          active: input.active
        }
      };
      const updateInput = {
        id: input._id,
        input: {
          firstName: input.firstName,
          lastName: input.lastName,
          email: input.email,
          phone: input.phone,
          // avatar: input.avatar,
          // password: "",
          civilIdNumber: input.civilIdNumber,
          civilIdImageBack:
            typeof this.customerModelObj.civilIdImageBack === "string"
              ? null
              : this.customerModelObj.civilIdImageBack,
          civilIdImageFront:
            typeof this.customerModelObj.civilIdImageFront === "string"
              ? null
              : this.customerModelObj.civilIdImageFront,
          // passportImageBack: this.passportBack,
          // passportImageFront: this.passportFront,
          active: input.active
        }
      };
      if (!this.isEditCustomer) {
        this.$apollo
          .query({
            query: require("@/user/api/queries/customer/check_exit_mobile.graphql"),
            fetchPolicy: "no-cache",
            variables: {
              phone: input.phone
            }
          })
          .then(response => {
            if (!response.data.checkPhoneExist) {
              createInput.input.password = input.newPassword;
              // createInput.input.civilIdImageFront = this.file || null;
              // createInput.input.civilIdImageBack = this.file1 || null;
              // createInput.input.passportImageFront =
              //   this.passportFrontFile || null;
              // createInput.input.passportImageBack =
              //   this.passportBackFile || null;
              signUp({ input: createInput.input }).then(response => {
                if (response.data.signUp.token) {
                  this.btnLoading = false;
                  this.$root.$emit("refetchCustomer");
                  this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
                  this.$store.commit("IS_EDIT_CUSTOMER", false);
                  this.$root.$emit("snackbar", {
                    snackbar: true,
                    text: this.$t("common.saveSuccess"),
                    color: "green"
                  });
                  this.customerModelObj = {
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    active: true
                    // civilIdImageFront: "",
                    // civilIdImageBack: "",
                  };
                  // this.file = null;
                  // this.file1 = null;
                  // this.passportFrontFile = null;
                  // this.passportBackFile = null;
                  this.reRender++;
                }
              });
            } else {
              this.btnLoading = false;
              this.isError = "Phone Number Already Exits";
              setTimeout(() => {
                this.isError = null;
              }, 5000);
            }
          });
      } else {
        if (typeof this.customerModelObj.avatar === "string") {
          updateInput.input.avatar = null;
        } else {
          updateInput.input.avatar = this.customerModelObj.avatar;
        }
        // updateInput.input.civilIdNumber =
        //   this.customerModelObj.civilIdNumber || "";
        // if (typeof this.customerModelObj.civilIdImageFront === "string") {
        //   updateInput.input.civilIdImageFront = null;
        // } else {
        //   if (this.customerModelObj.civilIdImageFront === null) {
        //     this.$root.$emit("snackbar", {
        //       snackbar: true,
        //       text: "Upload Civil Id Image Front",
        //       color: "error",
        //     });
        //     return false;
        //   }
        //   updateInput.input.civilIdImageFront =
        //     this.customerModelObj.civilIdImageFront;
        // }
        // if (typeof this.customerModelObj.civilIdImageBack === "string") {
        //   updateInput.input.civilIdImageBack = null;
        // } else {
        //   if (this.customerModelObj.civilIdImageBack === null) {
        //     this.$root.$emit("snackbar", {
        //       snackbar: true,
        //       text: "Upload Civil Id Image Back",
        //       color: "error",
        //     });
        //     return false;
        //   }
        //   updateInput.input.civilIdImageBack =
        //     this.customerModelObj.civilIdImageBack;
        // }

        // if (typeof this.customerModelObj.passportImageFront === "string")
        //   updateInput.input.passportImageFront = null;
        // else
        //   updateInput.input.passportImageFront =
        //     this.customerModelObj.passportImageFront;
        // if (typeof this.customerModelObj.passportImageBack === "string")
        //   updateInput.input.passportImageBack = null;
        // else
        //   updateInput.input.passportImageBack =
        //     this.customerModelObj.passportImageBack;
        if (this.customerModelObj.newPassword)
          updateInput.input.newPassword = this.customerModelObj.newPassword;

        updateCustomer(updateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_CUSTOMER", false);
            this.$root.$emit("refetchCustomer");
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
            this.customerModelObj = {
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              active: true
            };
            this.reRender++;
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      }
    }
    // onCancel() {
    //   this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
    //   this.$store.commit("IS_EDIT_CUSTOMER", false);
    // },
  }
};
</script>
<style scoped>
.numberClass >>> input[type="number"] {
  -moz-appearance: textfield;
}

.numberClass >>> input::-webkit-outer-spin-button,
.numberClass >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
